import { css } from '@emotion/react'
import { Flow, Text } from 'bold-ui'

interface SdcSecaoAlertaProps {
  titulo?: string
  conteudo?: string
  children?: React.ReactNode
  paddingConteudoHorizontal?: boolean
  paddingConteudoTop?: boolean
}

export const SdcSecaoAlerta = (props: SdcSecaoAlertaProps) => {
  const { titulo, conteudo, children, paddingConteudoHorizontal = false, paddingConteudoTop = false } = props

  if (!conteudo) return null

  const styles = createStyles(paddingConteudoHorizontal, paddingConteudoTop)

  return (
    <Flow direction='vertical' gap={0.5}>
      {titulo && <Text variant='h4' dangerouslySetInnerHTML={{ __html: titulo }} />}
      {conteudo && (
        <div css={styles.conteudoTextHtml}>
          <Text component='div' dangerouslySetInnerHTML={{ __html: conteudo }} />
        </div>
      )}
      {children}
    </Flow>
  )
}

const createStyles = (paddingConteudoHorizontal: boolean, paddingConteudoTop: boolean) => ({
  conteudoTextHtml: css`
    padding-top: ${paddingConteudoTop ? 1 : 0}rem;
    padding-right: ${paddingConteudoHorizontal ? 1 : 0}rem;
    padding-bottom: 0;
    padding-left: ${paddingConteudoHorizontal ? 1 : 0}rem;

    p:not(:first-of-type) {
      margin-top: 0.5rem;
    }

    p + ul {
      margin-top: 0.5rem;
    }

    ul {
      margin: 0;
      padding-left: 1.5rem;
      list-style: disc outside;
    }

    ul > li:not(:first-of-type):not(ul ul > li) {
      margin-top: 0.5rem;
    }

    ul ul > li {
      margin-top: 0.5rem;
    }

    ul > li > .atencaoBox {
      margin-top: 0.5rem;
    }

    .quebraLinha + p {
      margin-top: 0;
    }
  `,
})
